module.exports = __webpack_public_path__ + "static/img/SourceSansPro-SemiBold.5a3f6a5.svg";